<template>
  <div class="footer">
    <div class="footer__top">
      <div class="footer__copyright">
        ⓒ {{ new Date().getFullYear() }} Nexon Korea Corporation & Toben Studio Inc. All Rights Reserved.
      </div>
      <div class="footer__links">
        <a href="https://maplestoryworlds.nexon.com/en/legal/tos/1007" target="_blank">Privacy Policy</a>
        <a href="https://maplestoryworlds.nexon.com/en/legal/tos/1013" target="_blank">Terms of Use</a>
        <a href="https://www.nexon.com/main/cookie-policy" target="_blank">Cookie Policy</a>
        <a id="otPrefCenter" class="ot-sdk-show-settings">Cookie Settings</a>
      </div>
    </div>

    <div class="footer__logos">
      <div class="footer__logos__nexon"></div>
      <div class="footer__logos__toben-studio"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {}
  },
  mounted() {
    this.OneTrust()
  },
  methods: {
    OneTrust() {
      // Hide Cookie Settings menu if it is "Cookie Settings" ( The text becomes to "Cookie Settings" on Global IP)
      // Keep checking the text up to 6 seconds
      let cookieMenuTimeCount = 0
      const checkCookieSettingMenu = setInterval(updateCookieSettingMenu, 300)
      function updateCookieSettingMenu() {
        const $cookieSettingMenu = document.querySelector('.ot-sdk-show-settings')
        if ($cookieSettingMenu.firstChild.nodeValue.includes('Cookie')) {
          $cookieSettingMenu.style.display = 'none'
        } else {
          $cookieSettingMenu.style.display = 'inline-block'
        }
        cookieMenuTimeCount++
        if (cookieMenuTimeCount > 20) {
          clearInterval(checkCookieSettingMenu)
        }
      }
    },
  },
}
</script>

<style lang="scss">
@use '@/assets/scss/helpers' as *;

@font-face {
  font-family: 'KlavikaNX-Regular';
  src: url('@/assets/fonts/KlavikaNX/KlavikaNX-Regular.otf') format('truetype');
}

.footer {
  position: relative;
  font-size: pxToRem(26);
  font-family: 'KlavikaNX-Regular';
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-left: pxToRem(50);
  padding-right: pxToRem(50);
  padding-top: pxToRem(79);
  padding-bottom: pxToRem(89);
  background-color: #000;
  border-top: pxToRem(3.1) solid #099fd2;
  color: #fff;

  .footer__top {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding-bottom: pxToRem(15);
    margin-bottom: pxToRem(15);
    &:after {
      content: '';
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: 97.5%;
      height: pxToRem(2);
      background-color: #2a2a2a;
    }
  }

  .footer__copyright {
    padding-right: pxToRem(40);
  }

  .footer__links {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    position: relative;

    .footer__links__separator-1,
    .footer__links__separator-2 {
      display: none;
    }

    a {
      color: #fff;
      text-decoration: none;
      margin: 0 pxToRem(10);
      transition: color 0.25s;
      position: relative;
      line-height: 1;

      &:hover {
        color: rgba(#fff, 0.6);
        cursor: pointer;
        transition: color 0.25s;
      }
      &:before {
        content: '';
        position: absolute;
        left: pxToRem(-10);
        top: 50%;
        transform: translateY(-50%);
        width: pxToRem(2);
        height: 100%;
        background-color: #418fa3;
        pointer-events: none;
      }
      &:first-child {
        margin-left: 0;
        &:before {
          content: none;
        }
      }
      &:last-child {
        margin-right: 0;
      }

      &.hidden {
        display: none;
      }
    }
  }

  .footer__logos {
    flex: 0 0 100%;
    max-width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-end;
    margin-top: pxToRem(36);
    .footer__logos__nexon,
    .footer__logos__toben-studio {
      background-size: contain;
      background-position: left bottom;
      background-repeat: no-repeat;
      margin: 0 pxToRem(26);
    }
    .footer__logos__nexon {
      width: pxToRem(111);
      height: pxToRem(32);
      background-image: url('@/assets/images/footer/nexon.png');
    }

    .footer__logos__toben-studio {
      width: pxToRem(68);
      height: pxToRem(37);
      background-image: url('@/assets/images/footer/toben-studio.png');
    }
  }
}

@mixin mobileTablet() {
  .footer {
    font-size: pxToRemTablet(25);
    padding-left: pxToRemTablet(20);
    padding-right: pxToRemTablet(20);
    padding-top: pxToRemTablet(47);
    padding-bottom: pxToRemTablet(66);
    border-width: pxToRemTablet(2);

    .footer__top {
      margin-bottom: pxToRemTablet(54);
      padding-bottom: pxToRemTablet(59);
      &::after {
        width: 80%;
        height: pxToRemTablet(2);
      }
    }

    .footer__copyright {
      flex: 0 0 100%;
      max-width: 100%;
      text-align: center;
      padding-right: 0;
      margin-bottom: pxToRemTablet(2);
    }

    .footer__links {
      flex: 0 0 100%;
      width: 100%;
      max-width: 100%;
      font-size: pxToRemTablet(25);
      padding-bottom: pxToRemTablet(0);
      margin-bottom: pxToRemTablet(0);

      a {
        margin: 0 pxToRemTablet(10);

        &:before {
          left: pxToRemTablet(-10);
          width: pxToRemTablet(2);
        }
        &:nth-child(5) {
          &:before {
            content: none;
          }
        }
      }
      .footer__links__separator-1,
      .footer__links__separator-2 {
        flex: 0 0 100%;
        max-width: 100%;
        height: pxToRemTablet(24);
      }
      .footer__links__separator-1 {
        display: block;
      }
      &:after {
        height: pxToRemTablet(2);
        width: 60%;
      }
    }

    .footer__logos {
      margin-top: pxToRemTablet(27);
      .footer__logos__nexon,
      .footer__logos__toben-studio {
        margin: 0 pxToRemTablet(26);
      }
      .footer__logos__nexon {
        width: pxToRemTablet(111);
        height: pxToRemTablet(32);
      }

      .footer__logos__toben-studio {
        width: pxToRemTablet(68);
        height: pxToRemTablet(37);
      }
    }
  }
}

.mobile,
.tablet {
  @include mobileTablet();
}
@function pxToRemTablet($px, $fontBase: 26, $round: true, $fractionDigits: 3) {
  @return pxToRem($px, $fontBase, $round, $fractionDigits);
}
@media screen and (max-width: 1024px) {
  @include mobileTablet();
}
</style>
